export const getCustomerReferenceAccount = (customer) => {
    var _a, _b;
    return ((_b = (_a = customer === null || customer === void 0 ? void 0 : customer._embedded) === null || _a === void 0 ? void 0 : _a.referenceAccounts) === null || _b === void 0 ? void 0 : _b.length)
        ? customer._embedded.referenceAccounts[0]
        : {};
};
//# sourceMappingURL=referenceAccount.js.map